import ClipLoader from "react-spinners/ClipLoader";

interface ActivityIndicatorProps {
  overlay?: boolean;
}
const ActivityIndicator = ({ overlay }: ActivityIndicatorProps) => {
  if (!overlay) {
    return (
      <div className="flex h-96 justify-center items-center">
        <ClipLoader size={50} />
      </div>
    );
  }
  return (
    <div className="fixed inset-x-0 top-0 z-50 h-full bg-gray-900 bg-opacity-50 w-full flex items-center justify-center">
      <div className="flex items-center">
        <ClipLoader size={50} />
      </div>
    </div>
  );
};

export default ActivityIndicator;
